import React from "react";
import * as HAN from '../../style/StyleComponentHeaderAndNav';
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import summaryGroupIcon from "../../assets/icons/group.svg";
import summaryCreditCardIcon from "../../assets/icons/credit_card.svg";
import summaryCreditScoreIcon from "../../assets/icons/credit_score.svg";
import summaryLightIcon from "../../assets/icons/light.svg";

const CustomerSummary: React.FC = () => {
    const customerData = useSelector((state:RootState) => state.customerData);

    return (
        <div className="flex justify-center">
            <HAN.UsageSummary className="h-[140px]" $width={540} style={{padding : '13px 0'}}>
                <div className="usage-items">
                    <div className="usage-icon-box">
                        <img src={summaryGroupIcon} alt=""/>
                    </div>
                    <p className="mb-3 text-[16px]">매칭 중</p>
                    <h6>{customerData.matching}</h6>
                </div>
                <div className="usage-items">
                    <div className="usage-icon-box">
                        <img src={summaryCreditCardIcon} alt=""/>
                    </div>
                    <p className="mb-3 text-[16px]">결제대기</p>
                    <h6>{customerData.payment_ready}</h6>
                </div>
                <div className="usage-items">
                    <div className="usage-icon-box">
                        <img src={summaryCreditScoreIcon} alt=""/>
                    </div>
                    <p className="mb-3 text-[16px]">결제완료</p>
                    <h6>{customerData.payment_success}</h6>
                </div>
                <div className="usage-items">
                    <div className="usage-icon-box">
                        <img src={summaryLightIcon} alt=""/>
                    </div>
                    <p className="mb-3 text-[16px]">시공완료</p>
                    <h6>{customerData.construction_complete}</h6>
                </div>
            </HAN.UsageSummary>
        </div>
    )
};

export default CustomerSummary;